export const moveToWorkingDay = (date) => {
    const currentDate = date ? new Date(date) : new Date()
    const dayOFWeek = currentDate.getDay()
    if (dayOFWeek < 5) {
        return currentDate
    }
    const nextDay = new Date(currentDate.setDate(currentDate.getDate() + 1))
    return moveToWorkingDay(nextDay)
}
